import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import rawDataSlice     from './slices/rawDataSlice'
// import suggestionSlice  from './slices/suggestionSlice'
// import searchSlice      from './slices/searchSrore'
import detailSlice      from './slices/detailSlice'

export const useProductStore = create(
  persist(
    devtools((set, get) => ({
      ...rawDataSlice(set, get),
      // ...suggestionSlice(set, get),
      // ...searchSlice(set, get),
      ...detailSlice(set, get),
    })),
    {
      name: 'product-store',
      getStorage: () => localStorage,
      partialize: state => ({
        currentProduct:      state.currentProduct,
        variants:            state.variants,
        currentRelatedItems: state.currentRelatedItems,
        currentAccessories:  state.currentAccessories,
        selectedVariant:      state.selectedVariant,
      }),
    }
  )
)